/* Fiche parfum — compléments mobile (Numerigram, v8.5 ; citation v8.24).
   Chargé par le bloc « Marque » du template produit. Objectif : le bouton panier arrive plus vite sur mobile.
   1. Galerie : des points à la place des miniatures (les miniatures restent le moteur).
   2. Citation du parfumeur repliée sur trois lignes (tous écrans), coupée entre deux mots, « Lire la suite » pour la déplier.
   3. Barre d'achat visible dès l'arrivée, effacée seulement pendant que le bouton principal est à l'écran.
   4. Message de stock du thème : apostrophe affichée « &#39; » corrigée (valable sur tous les écrans). */
(function () {
  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var mobile = function () { return window.matchMedia && matchMedia('(max-width: 989px)').matches; };

  /* 1. Points de galerie : un point clique sa miniature ; l'état actif est relu sur la miniature active */
  (function () {
    var liste = document.querySelector('.product__media-wrapper .product-single__thumbnails');
    if (!liste) return;
    var vignettes = [].slice.call(liste.querySelectorAll('.product-single__thumbnail'));
    if (vignettes.length < 2) return;
    var points = document.createElement('div');
    points.className = 'sdo-fp-points';
    points.setAttribute('role', 'group');
    points.setAttribute('aria-label', en ? 'Product photos' : 'Photos du produit');
    vignettes.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sdo-fp-points__pt';
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' / ' + vignettes.length);
      b.addEventListener('click', function () { v.click(); });
      points.appendChild(b);
    });
    var bloc = liste.closest('.thumbnails-wrapper') || liste;
    bloc.parentNode.insertBefore(points, bloc);
    function maj() {
      for (var i = 0; i < vignettes.length; i++) {
        var on = vignettes[i].classList.contains('active-thumb');
        points.children[i].classList.toggle('is-actif', on);
        if (on) points.children[i].setAttribute('aria-current', 'true'); else points.children[i].removeAttribute('aria-current');
      }
    }
    maj();
    if (window.MutationObserver) new MutationObserver(maj).observe(liste, { attributes: true, subtree: true, attributeFilter: ['class'] });
  })();

  /* 2. Citation repliée sur trois lignes, sur tous les écrans. Le texte est coupé ENTRE DEUX MOTS
     (jamais au milieu d'un mot, comme le ferait le repli CSS), suivi de « … ». La classe is-mot
     neutralise le repli CSS. Sans ce script, la citation reste simplement entière. */
  (function () {
    var q = document.querySelector('.product__info-wrapper .sdo-fp-citation blockquote');
    if (!q) return;
    var plus = en ? 'Read more' : 'Lire la suite', moins = en ? 'Read less' : 'Réduire';
    var complet = q.textContent;
    var mots = complet.split(' ');
    var nbsp = String.fromCharCode(160);
    var ouvert = false;
    q.classList.add('is-mot');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sdo-fp-citation__plus';
    b.setAttribute('aria-expanded', 'false');
    b.textContent = plus;
    b.hidden = true;
    q.parentNode.insertBefore(b, q.nextSibling);
    function nettoyer(t) {
      while (t.length && ' ,;:.'.indexOf(t.charAt(t.length - 1)) > -1 || t.charAt(t.length - 1) === nbsp) t = t.slice(0, -1);
      return t;
    }
    function couper() {
      q.textContent = complet;
      if (ouvert) return;
      var lh = parseFloat(getComputedStyle(q).lineHeight) || 24;
      var max = lh * 3 + 2;
      if (q.scrollHeight <= max) { b.hidden = true; return; }
      b.hidden = false;
      var bas = 1, haut = mots.length - 1, garde = 1;
      while (bas <= haut) {
        var m = Math.floor((bas + haut) / 2);
        q.textContent = nettoyer(mots.slice(0, m).join(' ')) + '…';
        if (q.scrollHeight <= max) { garde = m; bas = m + 1; } else { haut = m - 1; }
      }
      q.textContent = nettoyer(mots.slice(0, garde).join(' ')) + '…';
    }
    b.addEventListener('click', function () {
      ouvert = !ouvert;
      q.classList.toggle('is-ouverte', ouvert);
      b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      b.textContent = ouvert ? moins : plus;
      couper();
    });
    var minuterie = null;
    window.addEventListener('resize', function () { clearTimeout(minuterie); minuterie = setTimeout(couper, 120); });
    couper();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(couper);
  })();

  /* 3. Barre d'achat sur mobile : la section la montre une fois le bouton dépassé ; ici, elle est aussi
     montrée avant d'y arriver. Cet observateur est créé après celui de la section, il est donc notifié
     après lui et c'est son choix qui s'applique. */
  (function () {
    var barre = document.querySelector('[data-sdo-fp-barre]');
    var cible = document.querySelector('.product__info-wrapper .product-form__cart-submit, .product__info-wrapper [name="add"]');
    if (!barre || !cible || !window.IntersectionObserver) return;
    new IntersectionObserver(function (es) {
      if (!mobile()) return;
      es.forEach(function (e) {
        var montrer = !e.isIntersecting;
        barre.classList.toggle('is-visible', montrer);
        document.body.classList.toggle('sdo-barre-on', montrer);
        if (montrer) { barre.removeAttribute('aria-hidden'); barre.inert = false; }
        else { barre.setAttribute('aria-hidden', 'true'); barre.inert = true; }
      });
    }).observe(cible);
  })();

  /* 4. Message de stock du thème (« Nous n&#39;avons que 5 articles ») : la traduction arrive échappée deux fois */
  (function () {
    var zone = document.querySelector('.product__info-wrapper');
    if (!zone || !window.MutationObserver) return;
    var ta = document.createElement('textarea');
    function nettoyer() {
      zone.querySelectorAll('.product-form__error-message').forEach(function (m) {
        var t = m.textContent;
        if (t.indexOf('&#') === -1 && t.indexOf('&amp;') === -1 && t.indexOf('&quot;') === -1) return;
        ta.innerHTML = t;
        m.textContent = ta.value;
      });
    }
    nettoyer();
    new MutationObserver(nettoyer).observe(zone, { childList: true, subtree: true, characterData: true });
  })();
})();